import { RTKQueryErrorAlert } from "@/shared/components/domain/errors/rtk-query-error-alert";
import { useGetDeliveryByProcessQuery } from "@/services/backend/deliveries/delivery/service";
import { useParams } from "react-router";
import PackageContents from "../_components/package-contents";
import DeliveryState from "./delivery-state";

export default function StatusIndexRoute() {
  const { processId } = useParams();
  const { data, isLoading, error } = useGetDeliveryByProcessQuery({
    processId: processId as string,
  });

  if (isLoading || data == null) {
    return (
      <div className="w-full animate-pulse space-y-4 text-gray-300">
        <div className="block w-full rounded-lg border border-gray-200 bg-white p-4">
          <h5 className="mb-2 text-xl font-bold tracking-tight text-gray-300">
            Lade Lieferung
          </h5>
          <div className="mb-4 h-2.5 w-48 rounded-full bg-gray-200" />
          <div className="mb-2.5 h-2 max-w-[300px] rounded-full bg-gray-200" />
          <div className="mb-2.5 h-2 max-w-[300px] rounded-full bg-gray-200" />
          <div className="mb-2.5 h-2 max-w-[300px] rounded-full bg-gray-200" />
          <div className="mb-2.5 h-2 max-w-[300px] rounded-full bg-gray-200" />
        </div>
      </div>
    );
  }

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  return (
    <div className="space-y-4">
      {data != null && <DeliveryState deliveryId={data.id} />}
      <PackageContents delivery={data} />
    </div>
  );
}
